import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/view/components/ui/select";
import { Dialog } from "@/view/components/ui/dialog";
import ButtonBack from "@/view/components/ButtonBack";
import Card from "@/view/components/Card";
import { Spinner } from "@/view/components/ui/spinner";
import { EmptyMessage } from "@/view/components/EmptyMessage";
import { addMoneySimbols } from "@/app/utils/formatMoneyValue";
import { Table } from "lucide-react";
import MakeProposalCard from "./components/MakeProposalCard";
import { OfferCard } from "./components/OfferCard";
import NewPanModal from "./components/NewPanModal";
import usePanSimulation from "./usePanSimulation";

export default function PanSimulation() {
  const {
    offers,
    selectedPrazo,
    prazoOptions,
    selectedValue,
    customerInfo,
    selectedCondition,
    loadingOffers,
    errorMessage,
    setSelectedCondition,
    handleChangePrazo,
    handleMakeProposal,
  } = usePanSimulation();

  return (
    <div>
      <ButtonBack label={customerInfo?.name} />
      <div className="flex flex-col gap-8 xl:flex-row">
        <section className="flex flex-col gap-5 rounded-2xl border border-gray01 p-5 sm:min-w-[461px]">
          <Card className="flex grow flex-row items-start justify-between gap-4">
            <div className="flex flex-col">
              {loadingOffers ? (
                <div className="mt-9 flex items-center justify-center">
                  <Spinner />
                </div>
              ) : errorMessage ? (
                <div className="w-[350px]">
                  <p className="mb-2 text-sm font-normal text-black04">
                    Nenhuma condição encontrada
                  </p>
                  <p className="text-lmd font-normal text-black01">
                    {errorMessage}
                  </p>
                </div>
              ) : (
                <>
                  <p className="mb-4 text-sm font-normal text-black04">
                    Saldo disponível para saque
                  </p>
                  <h3 className="text-4xl font-normal text-black01">
                    {addMoneySimbols(selectedCondition?.valor_cliente || 0)}
                  </h3>
                </>
              )}
            </div>

            <div>
              <p className="mb-4 text-sm font-normal text-black04">Parcelas</p>
              <Select
                defaultValue={selectedPrazo?.toString() || ""}
                onValueChange={(value) => handleChangePrazo(Number(value))}
              >
                <SelectTrigger className="w-20 text-lg">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  {prazoOptions?.map((prazo) => (
                    <SelectItem
                      key={prazo.value}
                      value={prazo.value.toString()}
                    >
                      {prazo.label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          </Card>

          <Dialog>
            <MakeProposalCard
              disabled={!!errorMessage}
              onSubmitProposal={handleMakeProposal}
            />
            <NewPanModal />
          </Dialog>
        </section>
      </div>

      <div className="z-10 my-10 flex overflow-x-auto border-b" />

      <div className="flex gap-4 overflow-x-auto p-4">
        {loadingOffers ? (
          <div className="flex w-full justify-center py-10">
            <Spinner />
          </div>
        ) : errorMessage ? (
          <EmptyMessage
            className="w-full"
            icon={<Table size={64} />}
            title="Nenhuma condição encontrada"
            description={errorMessage}
          />
        ) : (
          offers?.conditions?.map((condicao, index) => (
            <OfferCard
              key={index}
              offer={condicao}
              selectedValue={selectedValue}
              commission={offers.commission}
              isSelected={
                selectedCondition?.codigo_tabela_financiamento ===
                condicao.codigo_tabela_financiamento
              }
              onClick={() => setSelectedCondition(condicao)}
            />
          ))
        )}
      </div>
    </div>
  );
}
